import { createFocusTrap as create, FocusTrap, Options as FocusTrapOptions } from 'focus-trap';

const queue: FocusTrap[] = [];

function getCurrent() {
  if (queue.length) {
    return queue[queue.length - 1];
  }

  return undefined;
}

function removeFromQueue(focusTrap: FocusTrap) {
  queue.splice(queue.indexOf(focusTrap), 1);
}

function createFocusTrap($el: HTMLElement, options: FocusTrapOptions = {}) {
  const { onDeactivate: originalOnDeactivate } = options;

  const focusTrap = create($el, ({
    ...options,
    onDeactivate: () => {
      removeFromQueue(focusTrap);

      const current = getCurrent();

      if (current) {
        current.unpause();
      }

      if (originalOnDeactivate) {
        originalOnDeactivate();
      }
    },
  }));

  const currentTrap = getCurrent();

  if (currentTrap) {
    currentTrap.pause();
  }

  queue.push(focusTrap);

  return focusTrap;
}

export default {
  createFocusTrap,
};
